"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrokerDetailsEndpoint = getBrokerDetailsEndpoint;
function getBrokerDetailsEndpoint(brokerBusinessPartnerId) {
    return `/broker-details/${brokerBusinessPartnerId}`;
}
//# sourceMappingURL=marketing-cards.js.map